import React from 'react';
import c from 'classnames';
import Loader from './Loader';

interface Props extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    kind?: 'primary' | 'secondary' | 'tertiary' | 'outline' | 'danger';
    children: React.ReactNode;
    state?: 'READY' | 'SAVING';
    small?: boolean;
}

export default function Button({
    kind = 'primary',
    disabled,
    type = 'button',
    onClick,
    className,
    children,
    state = 'READY',
    small = false,
    ...props
}: Props) {
    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={c('text-sm font-medium leading-5 rounded shadow-lg', className, {
                'hover:shadow-xl': !disabled,
                'text-white': kind !== 'outline' && !disabled,
                'opacity-50': disabled,
                'bg-green-500 hover:bg-green-700': kind === 'primary',
                'bg-gray-500 hover:bg-gray-700': kind === 'secondary',
                'bg-red-500 hover:bg-red-700': kind === 'danger',
                'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500': kind === 'tertiary',
                'border border-gray-300 text-gray-700 rounded-md transition duration-500 ease select-none hover:bg-gray-300 focus:outline-none focus:shadow-outline':
                    kind === 'outline',
                'py-2 px-4': !small,
                'text-sm px-1': small,
            })}
            {...props}
        >
            {state === 'READY' ? (
                children
            ) : (
                <span className={c({ 'text-white': kind !== 'outline' })}>
                    <Loader small />
                </span>
            )}
        </button>
    );
}
